import React, { useMemo } from 'react'
import { DropDownGroupProps } from '~types'
import { useEventsStore } from 'store/useEventsStore'
import DropDownGroup from 'components/modules/DropDownGroup/DropDownGroup'

const DropDownEventFilter = ({ isLoading }: { isLoading?: boolean }) => {
  const { setFilteredEventName, activeArtistList, setIsNavigationClicked } = useEventsStore()

  const uniqueEventNames = useMemo(() => {
    return activeArtistList.map(artist => ({
      label: artist.name,
      value: artist.id
    }))
  }, [activeArtistList])

  const handleEventFilterChange = (eventName: string) => {
    setFilteredEventName(eventName || null)
    setIsNavigationClicked(false)
  }

  const dropDowns: DropDownGroupProps['dropDowns'] = [
    {
      id: 'shows-filter',
      dropDownOption: 'All Shows',
      options: uniqueEventNames
    }
  ]

  return (
    <div>
      <DropDownGroup
        dropDowns={dropDowns}
        onDropDownChange={handleEventFilterChange}
        theme='light'
        isLoading={isLoading}
      />
    </div>
  )
}

export default DropDownEventFilter
